import { css } from 'styled-components';
import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';

export const list: ThemedFunctor = ({
  theme,
  ordered,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.SMALL, SpacingName.ZERO])}
  padding-left: 1.1rem;
  list-style: ${ordered ? 'decimal' : 'square'};
`;
